import useAxios from "axios-hooks";

import { ServerDynamicViewSchema } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.types.ts";
import { Configuration } from "src/http/Configuration.api.ts";

export const useGetUISchema = () => {
  const [{ data: uiSchema, loading, error }] = useAxios(
    Configuration.Configuration().getUISchemaUrl()
  );

  return {
    uiSchema:
      !error && !loading ? (JSON.parse(uiSchema?.data) as ServerDynamicViewSchema) : undefined,
    loading,
    error,
  };
};
